import { createContext, useContext } from "react";
import DefaultMeetingStore, { MeetingStore } from "../customerMeetings/store/MeetingStore";
import DefaultUserStore, { UserStore } from "../user/store/UserStore";
import DefaultInMeetingAppStore, { InMeetingAppStore } from "../inMeetingApp/store/InMeetingAppStore";
import DefaultSearchStore, { SearchStore } from "../customerMeetings/store/SearchStore";

export interface IStore {
    meetingStore: MeetingStore;
    userStore: UserStore;
    inMeetingAppStore: InMeetingAppStore;
    searchStore: SearchStore;
}

export const store: IStore = {
    meetingStore: DefaultMeetingStore,
    userStore: DefaultUserStore,
    inMeetingAppStore: DefaultInMeetingAppStore,
    searchStore: DefaultSearchStore,
};

export const StoreContext = createContext(store);

export const useStore = () => {
    return useContext(StoreContext);
};
